<template>
  <div class="sidebar-footer">
    <div class="sidebar-footer__links">
      <template v-for="{ name, route, href, onClick } in links">
        <button v-if="onClick" :key="name" class="sidebar-footer__button" @click="onClick">
          {{ name }}
        </button>
        <NuxtLink v-if="route" :key="name" :to="route" class="sidebar-footer__link">
          {{ name }}
        </NuxtLink>
        <a v-if="href" :key="name" :href="href" target="_blank" class="sidebar-footer__link">
          {{ name }}
        </a>
      </template>
    </div>
    <div class="sidebar-footer__sep" />
    <BravadoText variant="caption1" class="sidebar-footer__date">Bravado Inc. © {{ year }}</BravadoText>
    <a :href="linkToMobileApp" target="_blank" rel="nofollow noopener noreferrer">
      <img
        src="./images/appstore.png"
        loading="lazy"
        width="242"
        height="78"
        alt="Install bravado app"
        class="sidebar-footer__appstore-image"
      />
    </a>
  </div>
</template>

<script>
import { LINK_TO_MOBILE_APP } from '~/constants/common';

export default {
  name: 'SidebarFooter',
  data() {
    return {
      allLinks: [
        {
          name: 'The War Room FAQ',
          route: '/war-room/posts/faq',
          // Hide war room specified links in sidebar
          warRoomLink: true,
        },
        {
          name: 'About Us',
          href: '/about-us',
        },
        {
          name: 'Legal and Privacy Center',
          href: 'https://info.bravado.co/',
        },
        {
          name: 'Blog',
          href: 'https://bravado.co/blog/',
        },
        {
          name: 'Contact Bravado',
          // We use handler instead of links for a SEO reason - google will follow the allLinks otherwise and spends a crawl budget
          onClick: () => {
            this.$modal.showWithRoute('CONTACT_US_MODAL');
          },
        },
        // Press on main page should be enough
        // {
        //   name: 'Press',
        //   href: 'https://bravado.co/press-events',
        // },
        {
          name: 'Sales Jobs',
          href: 'https://bravado.co/lp/jobs/open-roles-list',
        },
      ],
      year: new Date().getFullYear(),
      linkToMobileApp: LINK_TO_MOBILE_APP,
    };
  },
  computed: {
    /**
     * We should hide all war room specific links (terms for war room, faq) for non-warroom pages.
     */
    links() {
      const isWarRoomPage = this.$route.path.includes('/war-room/');
      if (isWarRoomPage) return this.allLinks;

      return this.allLinks.filter(({ warRoomLink }) => !warRoomLink);
    },
  },
};
</script>

<style scoped lang="scss">
.sidebar-footer {
  padding: 16px 23.5px 0;
  text-align: center;

  &__links {
    text-align: center;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  &__button {
    background: transparent;
    line-height: inherit;
    color: inherit;
    border: 0;
    margin: 0;
    padding: 0;
    cursor: pointer;
  }

  &__button,
  &__link {
    @include caption1;

    text-decoration: none;
    margin: 0 8px 12px;
    color: var(--gray-50);
    white-space: nowrap;
    transition: color 0.3s;

    &:hover {
      color: var(--gray-35);
    }
  }

  &__sep {
    margin: 16px 8px;
    height: 1px;
    background: var(--theme-color-text);
    opacity: 0.1;
  }

  &__date {
    color: var(--gray-50);
    margin-bottom: 16px;
  }

  &__appstore-image {
    width: 80px;
    height: auto;
  }
}
</style>
